export default "/_next/static/images/section-2-4eb665f6163c88f3a40e5c29d044ceb0.png";